// extracted by mini-css-extract-plugin
export var attachButton = "_cj-8";
export var sendButton = "_cj-2";
export var sendDisabled = "_cj-4";
export var sendEnabled = "_cj-3";
export var sendIcon = "_cj-6";
export var sendIconDisabled = "_cj-7";
export var sendStreaming = "_cj-5";
export var textarea = "_cj-1";
export var wrapper = "_cj-0";